// src/pages/Products/OTAUpload.tsx

import { useNavigate, useParams } from 'react-router-dom';
import { message } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import { OTAUploadForm } from '@/components/forms/OTAUploadForm';
import { uploadOTA } from '@/api/ota';
import { getCurrentDeveloperId } from '@/stores/authStore';

/**
 * OTA 固件上传页面（首次上传）
 */
export const OTAUpload = () => {
  const { productId } = useParams<{ productId: string }>();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const developerId = getCurrentDeveloperId();

  /**
   * 处理固件上传
   */
  const handleUpload = async (version: string, description: string, file: File): Promise<void> => {
    if (!productId) throw new Error('产品 ID 不能为空');

    try {
      await uploadOTA(productId, { version, description }, file);
      message.success(`固件上传成功！版本：v${version}`);

      // 无效化相关查询
      if (developerId) {
        queryClient.invalidateQueries({ queryKey: ['ota', developerId, productId] });
        queryClient.invalidateQueries({ queryKey: ['product', developerId, productId] });
      }

      // 跳转到 OTA 列表页
      navigate(`/products/${productId}/ota`);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : '上传失败，请检查参数后重试。';
      message.error(errorMessage);
      throw error;
    }
  };

  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">上传 OTA 固件</h1>
        <p className="text-gray-600">为产品上传第一个固件版本，后续可通过升级功能更新。</p>
      </div>

      <OTAUploadForm onSubmit={handleUpload} />
    </div>
  );
};